export default __webpack_public_path__ + "static/media/milk.638366e2.png";